export default "__VITE_ASSET__bd7a3099__"